import type { PlatformSettings } from "../models/platform-settings.model";
import { DEFAULT_PLATFORM_SETTINGS } from "./platform-settings.seed";

const PERSIST_KEY = "itaas:platform-settings:v1";

function loadFromStorage(): PlatformSettings | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(PERSIST_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PlatformSettings;
    if (
      typeof parsed.defaultTrialDays !== "number" ||
      (parsed.tenantCreationPolicy !== "open" &&
        parsed.tenantCreationPolicy !== "super_admin_only")
    ) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function saveToStorage(settings: PlatformSettings): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(PERSIST_KEY, JSON.stringify(settings));
}

let settings: PlatformSettings = loadFromStorage() ?? {
  ...DEFAULT_PLATFORM_SETTINGS,
};

export function getPlatformSettings(): PlatformSettings {
  return { ...settings };
}

export function updatePlatformSettings(
  patch: Partial<
    Pick<PlatformSettings, "defaultTrialDays" | "tenantCreationPolicy">
  >
): PlatformSettings {
  settings = {
    ...settings,
    ...patch,
    updatedAt: new Date().toISOString(),
  };
  saveToStorage(settings);
  return { ...settings };
}

export function resetPlatformSettings(): void {
  settings = { ...DEFAULT_PLATFORM_SETTINGS, updatedAt: new Date().toISOString() };
  saveToStorage(settings);
}
